import { supabase } from '@/lib/supabase'
import type {
  ApiError,
  Ingredient,
} from '@/types'

/**
 * Ingredient Service
 * Provides methods to interact with mix ingredients via Supabase
 */
function createIngredientService() {
  /**
   * Create a new ingredient within a mix
   */
  const createIngredient = async (mixId: string, ingredients: Ingredient[]): Promise<void> => {
    const { error } = await supabase
      .from('mixes')
      .update({ ingredients })
      .eq('id', mixId)

    if (error) {
      const apiError: ApiError = {
        message: error.message,
        status: 500,
      }
      throw apiError
    }
  }

  /**
   * Select an existing ingredient
   */
  const selectIngredient = async (mixId: string, ingredients: Ingredient[]): Promise<void> => {
    const { error } = await supabase
      .from('mixes')
      .update({ ingredients })
      .eq('id', mixId)

    if (error) {
      const apiError: ApiError = {
        message: error.message,
        status: 500,
      }
      throw apiError
    }
  }

  /**
   * Delete an ingredient
   */
  const deleteIngredient = async (mixId: string, ingredients: Ingredient[]): Promise<void> => {
    const { error } = await supabase
      .from('mixes')
      .update({ ingredients })
      .eq('id', mixId)

    if (error) {
      const apiError: ApiError = {
        message: error.message,
        status: 500,
      }
      throw apiError
    }
  }

  return {
    createIngredient,
    deleteIngredient,
    selectIngredient,
  }
}

export const ingredientService = createIngredientService()
